// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3kCnP","col":"CardReaderDesc_col__2X3vE","label":"CardReaderDesc_label__1nQs3"};